<h2 mat-dialog-title>Release Notes</h2>

<mat-dialog-content>
  {{ releaseNotes }}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
